export default state => {
  let planMedical = state.medical?.medicalBenefits?.planMedical;
  if (planMedical)
    state.medical.medicalBenefits.planMedical = convertToArray(planMedical);

  let drugList = state.pharmacy?.drugList?.link;
  if (drugList) state.pharmacy.drugList.link = convertToArray(drugList);

  let planDentalChart = state.dental?.dentalPlansChart?.planDentalChart;
  if (planDentalChart)
    state.dental.dentalPlansChart.planDentalChart = convertToArray(
      planDentalChart
    );

  let planDental = state.dental?.dentalPlans?.planDental;
  if (planDental)
    state.dental.dentalPlans.planDental = convertToArray(planDental);

  let moreEnrollmentMaterials = state.moreEnrollmentMaterials?.resource;
  if (moreEnrollmentMaterials)
    state.moreEnrollmentMaterials.resource = convertToArray(
      moreEnrollmentMaterials
    );

  console.log(state.moreEnrollmentMaterials);

  let benefitDetails = state.benefitDetails?.resource;
  if (benefitDetails)
    state.benefitDetails.resource = convertToArray(
      benefitDetails
    );

};

function convertToArray(val) {
  if (!Array.isArray(val) && typeof val === 'object') return [val];
  return val;
}
